import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { now } from "moment";
import { translate, formatDateToPtbr, formatDate, isNullOrEmpty } from '../../../utils/util';
import { onValueChange } from '../../../utils/handleChangeHooks';
import { Input, Button, Select, Breadcrumbs, Preloader } from '../../../components/UI/ComponentsUI';
import { ENUMS } from '../../../utils/constants';
import { getVision } from '../../../services/auth';
import AreaService from '../../../services/AreaService';
import MonitorService from '../../../services/MonitorService';
import { startLoading, endLoading } from '../../../actions/loadingAction';
import * as monitorAction from '../../../actions/monitorAction';

const Monitor = (props) => {
    const [search, setSearch] = useState(false);
    const [filter, setFilter] = useState({
        dateStart: formatDate(now()),
        dateEnd: formatDate(now()),
        shed: '',
    });

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const filterLinePicking = () => {
        if (!isNullOrEmpty(filter.shed)) {
            filter.areas = props.areas.items.find((i) => i.code === filter.shed).units;
        }
        return filter;
    }

    useEffect(() => {
        props.getAreas(getVision(), {
            PlantId: getVision().split('-')[0],
            AreaType: ENUMS.eAreaType.Shed.value
        }, {
            PageSize: ENUMS.ePagination.PageSize.value
        });

        // eslint-disable-next-line
    }, []);

    const reset = () => {
        setSearch(false);
        props.resetMonitor();
    }

    const onConfirm = () => {
        reset();
        props.showLoading();
        props.getrequestsAnswered(filterLinePicking());
        props.getReceivedVolumes(filter);
        setSearch(true);
    }

    return (
        <>
            <div>
                <Breadcrumbs id="configMonitor" title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('menu:monitor') }} />
            </div>
            <div className="container-fluid" style={{ marginTop: '25px' }}>
                <div className="container">
                    <div className="input-field no-padding col s12 mb-8" style={{ marginBottom: '10px', marginTop: '10px' }}>
                        <fieldset className='fieldset'>
                            <legend style={{ padding: "0 5px" }}>
                                {translate('change-location:period')}
                            </legend>
                            <form>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        defaultValue={filter.dateStart}
                                        type="date"
                                        label={translate('change-location:startDate')}
                                        id="dateStart"
                                        name="dateStart"
                                        onChange={onChange}
                                        required
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        defaultValue={filter.dateEnd}
                                        type="date"
                                        label={translate('change-location:endDate')}
                                        id="dateEnd"
                                        name="dateEnd"
                                        onChange={onChange}
                                        required
                                    />
                                </div>
                                <div className="input-field no-padding col s12 mb-8" style={{ marginBottom: '30px' }}>
                                    <Select
                                        id="shed"
                                        name="shed"
                                        valuefield="code"
                                        display="description"
                                        label={translate('shed', 'monitor')}
                                        placeHolder={translate('choose-one-option', 'general')}
                                        data={props.areas.items ? props.areas.items : []}
                                        change={onChange}
                                        defaultValue={filter.shed}
                                    />
                                </div>
                            </form>
                        </fieldset>
                        <div className="row" style={{ paddingTop: "5px" }}>
                            <Button
                                onClick={() => onConfirm()}
                                full="true"
                                text={translate("general:confirm")}
                            />
                        </div>
                    </div>
                    {
                        search &&
                        <>
                            <div className="card">
                                <div className="card-content" style={{ padding: '7px', paddingBlockEnd: '1px' }}>
                                    <div>
                                        <div className="row">
                                            <div className="input-field no-padding col s12" style={{ marginBottom: '10px' }}>
                                                <span className="field f-1p45r">Atendimento de Linha {formatDateToPtbr(filter.dateStart)} a {formatDateToPtbr(filter.dateEnd)}</span>
                                            </div>
                                            <div className="input-field no-padding col s12  mb-8" style={{ marginRight: '0' }} >
                                                <label className="active" htmlFor="cim">{translate('requestsAnswered', 'monitor')}</label>
                                                <span className="field f-1p45r">{props.requestsAnswered.quantity}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-content" style={{ padding: '7px', paddingBlockEnd: '1px' }}>
                                    <div>
                                        {
                                            props.receiveds.loading ? <Preloader /> : (
                                                <div className="row">
                                                    <div className="input-field no-padding col s12" style={{ marginBottom: '10px' }}>
                                                        <span className="field f-1p45r">Conferência Física {formatDateToPtbr(filter.dateStart)} a {formatDateToPtbr(filter.dateEnd)}</span>
                                                    </div>
                                                    <div className="input-field no-padding col s12  mb-8" style={{ marginRight: '0' }} >
                                                        <label className="active" htmlFor="cim">{`${translate('loadVolume', 'monitor')}`}</label>
                                                        <span className="field f-1p45r">{props.receiveds.quantityVolume}</span>
                                                    </div>
                                                    <div className="input-field no-padding col s12  mb-8" style={{ marginRight: '0' }} >
                                                        <label className="active" htmlFor="cim">{`${translate('receivedVolumes', 'monitor')}`}</label>
                                                        <span className="field f-1p45r">{props.receiveds.quantityVolumeReceived}</span>
                                                    </div>
                                                    <div className="input-field no-padding col s12  mb-8" style={{ marginRight: '0' }} >
                                                        <span className="field f-1p45r">{props.receiveds.quantityMvm}</span>
                                                        <label className="active" htmlFor="cim">{`${translate('totalLoadMvm', 'monitor')}`}</label>
                                                    </div>
                                                    <div className="input-field no-padding col s12  mb-8" style={{ marginRight: '0' }} >
                                                        <span className="field f-1p45r">{props.receiveds.quantityMvmReceived}</span>
                                                        <label className="active" htmlFor="cim">{`${translate('mvmReceived', 'monitor')}`}</label>
                                                    </div>
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        areas: state.areaReducer.areas,
        requestsAnswered: state.monitorReducer.requestsAnswered,
        mvmReceived: state.monitorReducer.mvmReceived,
        locationExchanges: state.monitorReducer.locationExchanges,
        receiveds: state.monitorReducer.receivedVolumes,
        mvmCarregados: state.monitorReducer.mvmCarregados,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAreas: (vision, filter, pagination) => {
            dispatch(AreaService.getAreas(vision, filter, pagination));
        },
        getrequestsAnswered: (filter, callback) => {
            dispatch(MonitorService.getrequestsAnswered(filter, callback));
        },
        getReceivedVolumes: (filter, callback) => {
            dispatch(MonitorService.getReceivedVolumes(filter, callback));
        },
        getMvmCarregados: (filter, callback) => {
            dispatch(MonitorService.getMvmCarregados(filter, callback));
        },
        resetMonitor: () => {
            dispatch(monitorAction.resetMonitor());
        },
        showLoading: () => {
            dispatch(startLoading());
        },
        hideLoading: () => {
            dispatch(endLoading());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Monitor)));
